// extracted by mini-css-extract-plugin
module.exports = {"configuration":"ConfigureCard_configuration__11SI6"};